<mat-card class="fixed-language-card" [style]="style">
  <mat-card-header>

  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col pe-0" [ngClass]="{'pe-2': !displayHighlightFields}">
        <mat-form-field class="fixed-language-control">
          <mat-label>{{ 'Common.Language' | translate }}</mat-label>
          <mat-select [formControl]="selectedLanguageControl" (selectionChange)="onLanguageControlChange($event)">
            @for (language of possibleLanguages; track language) {
              <mat-option [value]="language.languageCode">
                {{ language.name }}
              </mat-option>
            }
          </mat-select>
          <app-info-icon [key]="infoTextKey" class="ms-2 display-inline icon-button" matSuffix></app-info-icon>
        </mat-form-field>
      </div>
      @if (displayHighlightFields) {
        <div class="col mt-05-em px-0">
          @if (!highlightFields) {
            <button mat-icon-button
              [matTooltip]="highlightFieldsTooltip"
              (click)="toggleHighlight()">
              <mat-icon class="icon">highlight</mat-icon>
            </button>
          }
          @if (highlightFields) {
            <button mat-icon-button
              [matTooltip]="unhighlightFieldsTooltip"
              (click)="toggleHighlight()">
              <mat-icon class="icon">highlight_off</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>